import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ReconciledIcon = () => /*#__PURE__*/_jsxs("svg", {
  "data-testid": "qbo-reconciled",
  width: "24",
  height: "24",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "9.5",
    fill: "#529e36"
  }), /*#__PURE__*/_jsx("rect", {
    x: "6.07465",
    y: "8.0257",
    width: "5.70489",
    height: "3",
    transform: "rotate(43.7525 6.07465 8.0257)",
    fill: "white"
  }), /*#__PURE__*/_jsx("rect", {
    x: "8",
    y: "9.99667",
    width: "7.17846",
    height: "3",
    transform: "rotate(-44.112 8 9.99667)",
    fill: "white"
  })]
});